export default {"src":"/_next/static/media/peaceful-butterfly.mono.840b1265.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};